import { render } from "./SignupPage.vue?vue&type=template&id=5354fb16"
import script from "./SignupPage.vue?vue&type=script&lang=js"
export * from "./SignupPage.vue?vue&type=script&lang=js"
script.render = render

export default script